// NOTE: 公開値なので env ではなく直接持つ。ホストごとの選び方は `resolveGtmId`、経緯は docs/tracking/README.md。
export const PRODUCTION_AUTH_HOSTNAME = 'auth.cowcamo.jp';
export const STAGING_AUTH_HOSTNAME = 'stg.auth.cowcamo.jp';

export const GTM_CONTAINER_IDS = Object.freeze({
  qa: 'GTM-WG356BSR',
  stg: 'GTM-PX5LJK7',
  prd: 'GTM-MH2X25W',
});

export const GTM_SCRIPT_ID = 'cowcamo-gtm';
export const GTM_SCRIPT_URL = 'https://www.googletagmanager.com/gtm.js';

// NOTE: 共通 GTM の転送タグはこのイベント名と category / action / label の 3 キーだけを読む。変えると無警告で捨てられる。
export const TRACKING_EVENT_NAME = 'cowcamo_custom_event';
